export default __webpack_public_path__ + "static/media/M1A_1.7ea7199b.png";